var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.usersItems,"outlined":_vm.outlined,"label":_vm.label,"chips":"","multiple":""},model:{value:(_vm.localUser),callback:function ($$v) {_vm.localUser=$$v},expression:"localUser"}})}
var staticRenderFns = []

export { render, staticRenderFns }